module.exports = __webpack_public_path__ + "83a21144ce4a6b77ef27ce85ae8c55a3.png";